
import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Building, Plus, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface CompanySwitcherProps {
  className?: string;
  variant?: "default" | "outline" | "ghost";
}

export default function CompanySwitcher({ className, variant = "outline" }: CompanySwitcherProps) {
  const { activeCompany, profile } = useAuth();
  const navigate = useNavigate();
  const isAdmin = profile?.role === 'admin';
  
  const handleCreateCompany = () => {
    navigate('/companies/new');
  };
  
  if (!activeCompany) {
    if (isAdmin) {
      return (
        <Button variant="outline" onClick={handleCreateCompany} className={className}>
          <Plus className="mr-2 h-4 w-4" />
          Create Company
        </Button>
      );
    }
    return (
      <Button variant="outline" disabled className={className}>
        <Building className="mr-2 h-4 w-4" />
        No Company Access
      </Button>
    );
  }
  
  return (
    <Button 
      variant={variant} 
      className={cn(
        "min-w-fit justify-between h-8 sm:h-9 shadow-none hover:shadow-sm transition-colors",
        "bg-gradient-to-br from-muted/30 to-muted/20 hover:from-muted/40 hover:to-muted/30",
        "border-border/60 px-2 sm:px-3",
        className
      )}
      onClick={() => navigate(`/companies/${activeCompany.id}`)}
    >
      <div className="flex items-center gap-2">
        <Building className="h-4 w-4 text-primary" />
        <span className="max-w-[100px] sm:max-w-[140px] truncate font-normal text-xs sm:text-sm">{activeCompany.name}</span>
      </div>
      <ChevronRight className="h-4 w-4 text-muted-foreground" />
    </Button>
  );
}
